import { Image, Rating, Stack, Typography, VisualAssetImage } from 'core/common/ui/ui-kit';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { NebReviewCardV2 } from 'core/flow/entities';
import { DateStyled, FooterStyled, CardWrapperStyled, BadgeStyled } from './styled';

type ReviewCardV2Props = {
  content: NebReviewCardV2;
};

export const ReviewCardV2 = ({ content }: ReviewCardV2Props) => {
  const { date, review, user, badge } = content;

  return (
    <CardWrapperStyled>
      <Rating value={5} readOnly size="small" />
      <Typography variant="text-body-sm" dangerouslySetInnerHTML={prepareHtml(review)} />
      <FooterStyled>
        <Stack direction="row" alignItems="center" gap={3}>
          {user.avatar && (
            <Image src={user.avatar.src} alt={user.avatar.alt} width={36} height={36} />
          )}
          <Stack>
            <Typography
              variant="text-heading-xs"
              dangerouslySetInnerHTML={prepareHtml(user.name)}
            />
            <BadgeStyled variant="text-body-2xs" component="span">
              <VisualAssetImage image={badge.icon} width={12} height={12} />
              {badge.text}
            </BadgeStyled>
          </Stack>
        </Stack>
        <DateStyled variant="text-body-2xs" dangerouslySetInnerHTML={prepareHtml(date)} />
      </FooterStyled>
    </CardWrapperStyled>
  );
};
